module.exports = {"pageTitleText":"FrontEnd","bulletinTitleText":"System Notification / User Guide ","isShowBulletinBoard":"Show In Home","userGuideText":"User Guide URL","sendMailToAdmin":"Email","bulletin":"Bulletin"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/frontends.json
// module id = UJjI
// module chunks = 3